import Swiper, { Lazy, Navigation, Thumbs } from "swiper";
import Subscribe from "../modules/subscribe";

const ProjectOpen = {
  init() {
    ProjectOpen.gallerySlider();
    ProjectOpen.relatedProjectsSlider();
    ProjectOpen.relatedProductsSlider();
    ProjectOpen.tabs();
    Subscribe.init();
  },

  tabs() {
    if (!$(".tabs").length) {
      return;
    }

    $(".tab-nav-item").on("click", function (e) {
      e.preventDefault();
      var btn = $(this);
      btn.siblings().removeClass("tab-nav-item--active");
      btn.addClass("tab-nav-item--active");

      var target = btn.data("target");

      if (target != "video") {
        var videoWrapper = btn.parent().siblings().find(".video");
        var videoElement = btn.parent().siblings().find("video")[0];

        if (videoWrapper.hasClass("playing")) {
          videoWrapper.removeClass("playing");
          videoElement.pause();
        }
      }

      $(".tab").each(function () {
        var tab = $(this);
        if (target == tab.data("tab")) {
          tab.fadeIn();
        } else {
          tab.hide();
        }
      });
    });
  },

  gallerySlider() {
    const wrapEl = $(".gallery-slider");
    if (!wrapEl.length) {
      return;
    }

    const thumbsSliderEl = wrapEl.find(".thumbs-slider")
    const gallerySliderEl = wrapEl.find(".large-slider");

    var thumbsSwiper = new Swiper(thumbsSliderEl[0], {
      spaceBetween: 8,
      slidesPerView: 2,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        400: {
          slidesPerView: 3,
        },
        600: {
          slidesPerView: "auto",
        }
      }
    });


    var largeSwiper = new Swiper(gallerySliderEl[0], {
      modules: [Lazy, Navigation, Thumbs],
      slidesPerView: 1,
      spaceBetween: 16,
      // loop: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: wrapEl.find(".slider-nav__btn-prev")[0],
        nextEl: wrapEl.find(".slider-nav__btn-next")[0],
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        }
      }
    });
  },

  relatedProductsSlider() {
    const wrapEl = $(".related");
    if (wrapEl.length) {
      let swiperInstance;

      function initializeSwiper() {
        swiperInstance = new Swiper(wrapEl.find(".related__slider")[0], {
          modules: [Lazy, Navigation],
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          navigation: {
            prevEl: wrapEl.find(".slider-nav__btn-prev")[1],
            nextEl: wrapEl.find(".slider-nav__btn-next")[1],
          },
          slidesPerView: "auto",
          spaceBetween: 16,
          loop: true,
          breakpoints: {
            900: {
              navigation: {
                prevEl: wrapEl.find(".slider-nav__btn-prev")[0],
                nextEl: wrapEl.find(".slider-nav__btn-next")[0],
              },
            }
          }
        });
      }

      initializeSwiper(); // Initialize Swiper initially

      // Update Swiper on window resize
      $(window).on('resize', function () {
        // Destroy previous instance if it exists
        if (swiperInstance) {
          swiperInstance.destroy();
        }
        // Reinitialize Swiper with updated options
        initializeSwiper();
      });
    }
  },


  relatedProjectsSlider() {
    const relatedEl = $(".projects-slider");
    if (!relatedEl.length) {
      return;
    }

    let swiperInstance;

    function initializeSwiper() {
      const sliderEl = relatedEl.find(".swiper");
      swiperInstance = new Swiper(sliderEl[0], {
        modules: [Lazy, Navigation],
        slidesPerView: "auto",
        loop: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        navigation: {
          prevEl: relatedEl.find(".slider-nav__btn-prev")[1],
          nextEl: relatedEl.find(".slider-nav__btn-next")[1],
        },
        breakpoints: {
          900: {
            navigation: {
              prevEl: relatedEl.find(".slider-nav__btn-prev")[0],
              nextEl: relatedEl.find(".slider-nav__btn-next")[0],
            },
          }
        }
      });
    }

    initializeSwiper(); // Initialize Swiper initially

    // Update Swiper on window resize
    $(window).on('resize', function () {
      // Destroy previous instance if it exists
      if (swiperInstance) {
        swiperInstance.destroy();
      }
      // Reinitialize Swiper with updated options
      initializeSwiper();
    });
  },
};

export default ProjectOpen;
